import React from 'react'
import PropTypes from 'prop-types'
import {Box, SimpleGrid, Stack, Image, useMultiStyleConfig} from '@chakra-ui/react'
import CustomLink from '../../custom-link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const QuickLinksBraun = ({quickLinksSchema}) => {
    const styles = useMultiStyleConfig('Footer', {variant: 'braun'})
    const {buildUrl} = useMultiSite()

    return (
        <SimpleGrid columns={{base: 2, lg: 4}} {...styles.simpleGrid}>
            {quickLinksSchema.map((item, index) => {
                const isExternalUrl = !!item?.is_external_url

                return (
                    <React.Fragment key={index}>
                        <Stack {...styles.benefitStack}>
                            <Image
                                src={item?.icon?.url}
                                alt={item?.icon?.description}
                                {...styles.benefitIcons}
                            />
                            <Box>
                                <CustomLink
                                    isExternal={isExternalUrl}
                                    href={
                                        isExternalUrl ? item?.cta?.href : buildUrl(item?.cta?.href)
                                    }
                                    {...styles.benefitText}
                                >
                                    {item?.cta?.title}
                                </CustomLink>
                            </Box>
                        </Stack>
                    </React.Fragment>
                )
            })}
        </SimpleGrid>
    )
}

QuickLinksBraun.propTypes = {
    quickLinksSchema: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string, title: PropTypes.string}),
            cta: PropTypes.shape({href: PropTypes.string, title: PropTypes.string}),
            is_external_url: PropTypes.bool,
        }),
    ).isRequired,
}

export default QuickLinksBraun
